<!-- 为你推荐 -->
<template>
<div>
    <swiper :options="swiperOptions">
        <swiper-slide v-for="item in list" :key="item.id">
            <div class="ig"><a href="#"><img :src="item.image|webpFormat(750)" alt=""></a></div>
            <div class="title"><a href="#" >{{item.title}}</a></div>
            <!-- <div class="tag">
                <span v-for="(tag,index) in item.tags" :key="index">{{tag}}</span>
            </div>
            <div class="phone">{{item.phone}}</div> -->
            <div class="desc">{{item.desc}}</div>
        </swiper-slide>
        
        <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
    
</div>
</template>
<script>
export default {
    name:'NetSale',
    data(){
        return {
             // 轮播图配置
            swiperOptions: {
                spaceBetween: 30,
                /* autoplay: {
                    delay: 3000,
                    stopOnLastSlide: false,
                    disableOnInteraction: false,
                }, */
                slidesPerView: 2,

                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
            },
            outbreakLoading:true,
            list:[
                {
                    title:'CA留学生必看，如何办理电话卡？',
                    tags:[],
                    phone:'',
                    image:'https://media4.imgyb.xyz/media/v1/image/439dd0cf90b07a01244fab12ea345854.png/webp750',
                    url:'https://news.yorkbbs.ca/detail/edu/367593a5-12b0-41e4-98c9-ea4497a02c4a',
                    desc:'开学季刚到加拿大，你想做的第一件事可能就是和家人报个平安，而这个的前提是：你需要一张电话卡！',
                },
                {
                    title:'最新！各大电信运营商开学季优惠套餐~',
                    tags:[],
                    phone:'',
                    image:'https://media7.imgyb.xyz/media/v1/image/c5fda1357db18c138497d5d695eeb87b.png/webp750',
                    url:'https://news.yorkbbs.ca/detail/edu/37c78ac7-1d5a-44f0-b8ff-36cc3da83366',
                    desc:'各大电信运营商的最新开学季优惠套餐有哪些？Bell、Rogers、Fido、TELUS学生专享套餐来啦~',
                },
                {
                    title:'如何选电信运营商？看这一篇就够了！',
                    tags:[],
                    phone:'',
                    image:'https://media5.imgyb.xyz/media/v1/image/370bd741ee19f195a14bb50fb73a07c3.png/webp750',
                    url:'https://news.yorkbbs.ca/detail/edu/fdce79d9-7ab9-48c8-87e8-052ffb1fdf57',
                    desc:'廉价运营商与主要运营商有什么区别？一起看看吧~',
                },
                {
                    title:'电话卡选Prepaid Plan 还是Contract Plan？',
                    tags:[],
                    phone:'',
                    image:'https://media2.imgyb.xyz/media/v1/image/413eb0188230cb732b3b972b0bdbdd61.png/webp750',
                    url:'https://news.yorkbbs.ca/detail/edu/6c0c1bce-c65c-4d78-ab92-095de6583268',
                    desc:'选择Prepaid Plan 还是Contract Plan？一起了解下~',
                },
            ]
        }
    }
}
</script>
<style lang="less" scoped>
/deep/.swiper-container{
    padding-bottom: 37px;
    .swiper-wrapper{
        .ig{
            margin-bottom: 5px;font-size: 0; position: relative; overflow: hidden; 
            &:after{padding-bottom: 47%; content: '';display: block;}
            a{position: absolute; left: 0; top: 0;right: 0; bottom: 0; border-radius: 4px; border:1px solid #eee; display: block;border-radius: 4px; overflow: hidden;
                img{display:block; width: 100%; height: 100%; object-fit: cover; transition: all 200ms linear;}
                &:hover{

                    img{transform: scale(1.1)};
                }
            }
        }
        .title{font-size: 16px; line-height: 24px; font-weight: 400; margin-bottom: 10px;
            a{display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 2; /*截取4行*/ text-overflow: ellipsis; overflow: hidden;}
            a:hover{color: #e43a3a;}
        }
        .tag{display: flex; margin-bottom: 10px; flex-wrap: wrap;
            span{color: #999; margin-right: 10px;}
        }
        .phone{font-size: 16px; line-height: 22px; color: #E43A3A; font-weight: 600;}
        .desc{font-size: 14px;line-height: 20px; color: #999; }
    }
}
@media screen and (max-width:768px){
    .desc{display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 1; /*截取4行*/ text-overflow: ellipsis; overflow: hidden;}
}
</style>